import toUrl from './to-url';

type T = (url?: string | URL) => string;

const f: T = (url = window.location.toString()) => toUrl(url).pathname;

export default f;
